<template lang="pug">
  div(style='text-align: center')
    h1 Not Found
</template>

<script>
export default {

}
</script>

<style>

</style>
